<template>
  <div>
    <v-card :class="mobile?'pa-0':'pa-5'">
      <v-card-title primary-title class="pl-5 text_title_2">
        {{
        WEB_LANGUAGE == "th"
        ? text.translation_chanel.th
        : WEB_LANGUAGE == "en"
        ? text.translation_chanel.en
        : "-"
        }}
      </v-card-title>
      <v-card-text>
        <v-form ref="card_request_word">
          <v-row>
            <v-col class="text_title_3 my-0 py-0" cols="12">
              {{
              WEB_LANGUAGE == "th"
              ? text.vocabulary.th
              : WEB_LANGUAGE == "en"
              ? text.vocabulary.en
              : "-"
              }}
            </v-col>
            <v-col class="text_title_3 my-0 py-0" cols="12">
              <v-text-field
                v-model="request_word"
                name="word"
                :placeholder="
                  WEB_LANGUAGE == 'th'
                    ? text.vocabulary_placeholder.th
                    : WEB_LANGUAGE == 'en'
                    ? text.vocabulary_placeholder.en
                    : '-'
                "
                id="word"
                :rules="rule_is_empty_textfield"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col class="text_title_3 my-0 py-0" cols="12">
              {{
              WEB_LANGUAGE == "th"
              ? text.language.th
              : WEB_LANGUAGE == "en"
              ? text.language.en
              : "-"
              }}
            </v-col>
            <v-col class="text_title_3 my-0 py-0" cols="12">
              <v-autocomplete
                :items="languageList"
                :item-text="
                  WEB_LANGUAGE == 'th' ? 'languageName' : 'languageNameEn'
                "
                item-value="languageId"
                v-model="language"
                name="language"
                :placeholder="
                  WEB_LANGUAGE == 'th'
                    ? text.language_placeholder.th
                    : WEB_LANGUAGE == 'en'
                    ? text.language_placeholder.en
                    : '-'
                "
                id="language"
                :rules="rule_is_empty_dropdown"
                outlined
                dense
              ></v-autocomplete>
            </v-col>

            <v-col class="text_title_3 my-0 py-0" cols="12">
              {{
              WEB_LANGUAGE == "th"
              ? text.more_info.th
              : WEB_LANGUAGE == "en"
              ? text.more_info.en
              : "-"
              }}
            </v-col>
            <v-col class="text_title_3 my-0 py-0" cols="12">
              <v-textarea
                v-model="comment"
                name="word"
                :placeholder="
                  WEB_LANGUAGE == 'th'
                    ? text.more_info_placeholder.th
                    : WEB_LANGUAGE == 'en'
                    ? text.more_info_placeholder.en
                    : '-'
                "
                id="word"
                textarea
                :rules="rule_is_empty_textfield"
                outlined
                dense
              ></v-textarea>
            </v-col>

            <v-col class="text_title_3 my-0 py-0" cols="12">
              {{
              WEB_LANGUAGE == "th"
              ? text.email.th
              : WEB_LANGUAGE == "en"
              ? text.email.en
              : "-"
              }}
            </v-col>
            <v-col class="text_title_3 my-0 py-0" cols="12">
              <v-text-field
                v-model="email"
                name="email"
                :placeholder="
                  WEB_LANGUAGE == 'th'
                    ? text.email_placeholder.th
                    : WEB_LANGUAGE == 'en'
                    ? text.email_placeholder.en
                    : '-'
                "
                id="email"
                :rules="rule_email"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="text_title_5">
            <v-col cols="12">
              {{
              WEB_LANGUAGE == "th"
              ? text.defualt_text.th
              : WEB_LANGUAGE == "en"
              ? text.defualt_text.en
              : "-"
              }}
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="sendRequestWord()">
          <font class="text_body_5">
            {{
            WEB_LANGUAGE == "th"
            ? text.submit_btn.th
            : WEB_LANGUAGE == "en"
            ? text.submit_btn.en
            : "-"
            }}
          </font>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import flag from "@/views/AppBehide/Settings/LanguageList.js";
import { bus } from "@/main";
import { text_searchHomePage } from "@/assets/javascript/dataLanguage.js";
import * as rules from "@/assets/javascript/rules.js";
export default {
  data() {
    return {
      WEB_LANGUAGE: "th",
      text: null,
      header_token: {
        headers: {
          token: "token_inet_dev",
        },
      },
      languageList: [],
      language: "",
      request_word: "",
      comment: "",
      email: "",
      rule_is_empty_textfield: rules.isEmptyTextField,
      rule_is_empty_dropdown: rules.isEmptyDropdown,
      rule_email: rules.email,
    };
  },
  computed: {
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    WEB_LANGUAGE(value) {
      if (value) {
        if (value == "th") {
          this.rule_is_empty_textfield = rules.isEmptyTextField;
          this.rule_is_empty_dropdown = rules.isEmptyDropdown;
          this.rule_email = rules.email;
        } else if (value == "en") {
          this.rule_is_empty_textfield = rules.isEmptyTextField_en;
          this.rule_is_empty_dropdown = rules.isEmptyDropdown_en;
          this.rule_email = rules.email_en;
        }
      }
    },
  },
  created() {
    // this.getLanguage();
    this.text = text_searchHomePage;
    bus.$on("switchLanguage", (data) => {
      this.WEB_LANGUAGE = data;
    });
  },
  beforeDestroy() {
    bus.$off("switchLanguage");
  },
  methods: {
    sendRequestWord() {
      if (this.$refs.card_request_word.validate()) {
        let data = {
          pointerId: 0,
          languageId: this.language,
          requestWordName: this.request_word,
          comment: this.comment,
          emailRequest: this.email,
        };
        this.axios
          .post(
            process.env.VUE_APP_API + "api/v1/requestword",
            data,
            this.header_token
          )
          .then((response) => {
            // console.log(response.data);
            if (response.data == "success") {
              this.$swal.fire({
                icon: "success",
                title:
                  this.WEB_LANGUAGE == "th"
                    ? this.text.swal_validate_title.th
                    : this.WEB_LANGUAGE == "en"
                    ? this.text.swal_validate_title.en
                    : "-",
                text:
                  this.WEB_LANGUAGE == "th"
                    ? this.text.swal_validate_text.th
                    : this.WEB_LANGUAGE == "en"
                    ? this.text.swal_validate_text.en
                    : "-",
                showConfirmButton: false,
                timer: 1000,
              });
              bus.$emit("getNotificationCounter", "GET");
              this.$refs.card_request_word.reset();
              this.$refs.card_request_word.resetValidation();
            }
          })
          .catch((err) => {
            // console.log("api get LanguageList detail err");
          });
      } else {
        this.$swal.fire({
          icon: "warning",
          title:
            this.WEB_LANGUAGE == "th"
              ? this.text.swal_invalidate_title.th
              : this.WEB_LANGUAGE == "en"
              ? this.text.swal_invalidate_title.en
              : "-",
          text:
            this.WEB_LANGUAGE == "th"
              ? this.text.swal_invalidate_text.th
              : this.WEB_LANGUAGE == "en"
              ? this.text.swal_invalidate_text.en
              : "-",
          showConfirmButton: false,
          timer: 1000,
        });
      }
    },
    getLanguage(data) {
      // this.axios
      //   .get(
      //     process.env.VUE_APP_API + "api/v1/masterdata/language",
      //     this.header_token
      //   )
      //   .then(response => {
      //     // console.log(response.data);
      //     this.languageList = response.data;
      //   })
      //   .catch(err => {
      //     console.log("api get LanguageList detail err");
      //   });
      this.languageList = data;
    },
  },
};
</script>
